export const constants = {
    defaultClientLead: {
        username: 'jkriggs'
    }
}